import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import LazyLoader from "./LazyLoader";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Swal from "sweetalert2";
import POServices from "../../../services/PoServices";
import LocationServices from "../../../services/LocationServices";
import AccountServices from "../../../services/AccountServices";
import getRequisitionPrintTemplate from "./getRequisitionPrintTemplate";
import getMRVPrintTemplate from "./getMRVPrintTemplate";
import Loader from '../Loader/loader'
const FilePreviewModal = React.lazy(() => import("./FilePreviewModal"));
const AccountPOModal = React.lazy(() => import("./AccountPOModal"));
const MRVPreviewModal = React.lazy(() => import("./MRVPreviewModal"));
const BillingApprovalModal = React.lazy(() => import("./BillingApprovalModal"));
const PaymentHistoryModal = React.lazy(() => import("./PaymentHistoryModal"));
const PoRevisionPrintModal = React.lazy(() => import("../PO/PoRevisionPrintModal"));


const BillingTeam = () => {

    useEffect(() => {

        console.log("BillingTeam Mounted");

        return () => {
            console.log("BillingTeam Unmounted");
        };

    }, []);
    const [open2, setOpen2] = useState(true);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);
    const [open, setOpen] = useState(false);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [storeOptions, setStoreOptions] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [showPOModal, setShowPOModal] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [selectedPO, setSelectedPO] = useState(null);
    const [supplierLoading, setSupplierLoading] = useState(false);
    const [storeLoading, setStoreLoading] = useState(false);
    const [showReqPreview, setShowReqPreview] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [reqHtml, setReqHtml] = useState("");
    const [overlayLoading] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedHistoryPoId, setSelectedHistoryPoId] = useState(null);
    const [tableLoading, setTableLoading] = useState(false);
    const [poData, setPoData] = useState(null);
    // ==========================================
    // PO PRINT / REVISION PREVIEW
    // ==========================================

    const [showPOPrintModal, setShowPOPrintModal] = useState(false);
    const [selectedPrintPO, setSelectedPrintPO] = useState(null);
    const [printLoadingId, setPrintLoadingId] = useState("");

    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "asc"
    });

    const [filters, setFilters] = useState({
        billNo: "",
        supplier: [],
        po: "",
        amount: "",
        amountCriteria: "",

        // ✅ CREATED AT RANGE
        createdMonthRange: 3,

        // ✅ BILLING DATE RANGE
        billingMonthRange: 3,

        store: ""
    });

    const [activeFilterKey, setActiveFilterKey] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [isAtEnd, setIsAtEnd] = useState(false);   // 🔥 ADD THIS
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [supplierFilterUI, setSupplierFilterUI] = useState("");
    const [storeFilterUI, setStoreFilterUI] = useState("");
    const [poTypeFilterUI, setPoTypeFilterUI] = useState("");
    const [showMRVPreview, setShowMRVPreview] = useState(false);
    const [mrvHtml, setMrvHtml] = useState("");



    useEffect(() => {
        fetchSuppliers();
        fetchStores();
    }, []);

    const fetchSuppliers = async () => {
        try {
            setSupplierLoading(true); // 🔥 START LOADING

            const res = await POServices.activeSuppliers();

            const supplierList =
                res?.data?.data || res?.data || [];

            const formatted = supplierList.map(s => ({
                value: s._id,
                label: s.name
            }));

            setSupplierOptions(formatted);

        } catch (err) {
            console.error("Supplier Error:", err);
            Swal.fire("Error", "Failed to load suppliers", "error");
        } finally {
            setSupplierLoading(false); // 🔥 STOP LOADING
        }
    };

    const fetchStores = async () => {
        try {
            setStoreLoading(true);

            const res = await LocationServices.getStore();

            const formatted = (res?.data?.data || []).map(s => ({
                value: s._id,
                label: s.name
            }));

            setStoreOptions(formatted);

        } catch (err) {
            console.error(err);
        } finally {
            setStoreLoading(false);
        }
    };

    const fetchData = async (customPayload = null) => {
        try {
            setTableLoading(true);

            let payload = customPayload || {
                ...filters,
                amount: filters.amount ? Number(filters.amount) : ""
            };

            // 🔥 FIX: ensure default 3 months always
            if (!payload.createdMonthRange) {
                payload.createdMonthRange = 3;
            }
            if (!payload.billingMonthRange) {
                payload.billingMonthRange = 3;
            }

            // ✅ CREATED RANGE
            if (payload.createdMonthRange > 0) {
                const { from, to } = getDateRangeFromMonths(payload.createdMonthRange);
                payload.fromDate = from;
                payload.toDate = to;
            }

            // ✅ BILLING RANGE
            if (payload.billingMonthRange > 0) {
                const { from, to } = getDateRangeFromMonths(payload.billingMonthRange);
                payload.billingFromDate = from;
                payload.billingToDate = to;
            }

            payload.viewType = "new"; // 🔥 IMPORTANT



            const res = await AccountServices.getBillingDataBySearch(payload);

            setTableData(res?.data || []);

        } catch (err) {
            console.error(err);
        } finally {
            setTableLoading(false);

            setIsFirstLoad(false); // 🔥 ADD THIS
        }
    };

    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // 🔥 RANGE → DATE
    const getDateRangeFromMonths = (months) => {
        const today = new Date();
        const past = new Date();
        past.setMonth(today.getMonth() - months);

        return {
            from: past.toISOString().split("T")[0],
            to: today.toISOString().split("T")[0]
        };
    };

    const handleSearch = async () => {

        // 🔥 EMPTY FILTER VALIDATION (NEW ADD)
        const isEmptySearch =
            filters.createdMonthRange === 0 &&
            filters.billingMonthRange === 0 &&
            !filters.po &&
            !filters.billNo &&
            !filters.amount &&
            !filters.amountCriteria &&
            (!filters.supplier || filters.supplier.length === 0) &&
            !filters.store;

        if (isEmptySearch) {
            Swal.fire(
                "Select Filter",
                "Please select at least one criteria before searching",
                "warning"
            );
            return;
        }

        // 🔥 EXISTING AMOUNT VALIDATION (UNCHANGED)
        if (
            (filters.amount && !filters.amountCriteria) ||
            (!filters.amount && filters.amountCriteria)
        ) {
            Swal.fire("Amount Filter", "Please select criteria and enter amount", "warning");
            return;
        }

        try {
            //setShowSkeleton(true); // 🔥 SHOW SKELETON
            await fetchData();
            setIsSearched(true);   // 🔥 ADD THIS
            setOpen(false);   // 🔥 ADD THIS

        } catch (err) {
            console.error(err);
        } finally {
        }
    };

    const formatDateTime = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")
            }/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")
            }:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")
            }`;
    };

    const getStatusLabel = (status) => {
        const map = {
            "Generated": "PO Checker",
            "Assigned-To-Maker": "PO Maker",
            "Assigned-To-Checker": "PO Checker",
            "Assigned-To-SuperAdmin": "HO",
            "Confirmed-Generated": "Pending Received Order",
            "Bill-Generated": "Accounts"
        };

        return map[status] || status; // fallback
    };

    const handleRequisitionPreview = async (requisitionId) => {
        try {
            setShowReqPreview(true);
            setReqHtml("");

            const res = await AccountServices.getItemsByRequisitionId(requisitionId);

            // ✅ FIXED
            const finalData = res?.data;

            if (!finalData) {
                throw new Error("No data found");
            }

            const htmlContent = getRequisitionPrintTemplate(finalData);

            setReqHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowReqPreview(false);
            Swal.fire("Error", "Failed to load Requisition", "error");
        }
    };
    const handleFailedRequisitionPreview = async (requisitionId, poNumber) => {
        try {
            setShowReqPreview(true);
            setReqHtml("");

            const res = await AccountServices.getItemsByRequisitionId(requisitionId);

            const finalData = res?.data;

            if (!finalData) {
                throw new Error("No data found");
            }

            // 🔥 FILTER ONLY FAILED ITEMS
            const filteredItems = (finalData.items || []).filter(item =>
                item.status === "supplier_failed" &&
                String(item.poNumber) === String(poNumber)
            );

            // 🔥 CREATE NEW OBJECT (KEEP SAME STRUCTURE)
            const modifiedData = {
                ...finalData,
                items: filteredItems
            };

            // ❗ IF NO FAILED ITEMS
            if (filteredItems.length === 0) {
                Swal.fire("No Failed Items", "No supplier failed items found for this PO", "info");
            }

            const htmlContent = getRequisitionPrintTemplate(modifiedData);

            setReqHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowReqPreview(false);
            Swal.fire("Error", "Failed to load Failed Requisition", "error");
        }
    };
    const handleMRVPreview = async (mrvId) => {
        try {
            // ✅ STEP 1: OPEN MODAL IMMEDIATELY
            setShowMRVPreview(true);
            setMrvHtml(""); // 🔥 triggers loader inside modal

            // ❌ REMOVE Swal loader completely

            // ✅ STEP 2: CALL API
            const res = await AccountServices.getMRVDataByTheMRVId([mrvId]);

            const finalData = res?.data?.[0]; // ✅ FIXED PATH


            const htmlContent = getMRVPrintTemplate(finalData);

            // ✅ STEP 3: SET DATA (loader disappears automatically)
            setMrvHtml(htmlContent);

        } catch (err) {
            console.error(err);
            setShowMRVPreview(false); // ✅ close modal if error
            Swal.fire("Error", "Failed to load MRV", "error");
        }
    };
    const handleMultiMRVPreview = async (mrvIds) => {
        try {
            // ✅ open modal + loader
            setShowMRVPreview(true);
            setMrvHtml("");

            const res = await AccountServices.getMRVDataByTheMRVId(mrvIds);

            const allData = res?.data || [];

            // ✅ merge all MRVs into ONE HTML
            const mergedHTML = `
      <html>
      <head>
        <title>All MRVs</title>
        <style>
          .page-break {
            page-break-after: always;
          }
        </style>
      </head>
      <body>
        ${allData
                    .map((mrv, index) => `
            <div>
              ${getMRVPrintTemplate(mrv)}
            </div>
            ${index !== allData.length - 1 ? `<div class="page-break"></div>` : ""}
          `)
                    .join("")}
      </body>
      </html>
    `;

            setMrvHtml(mergedHTML);

        } catch (err) {
            console.error(err);
            setShowMRVPreview(false);
            Swal.fire("Error", "Failed to load MRVs", "error");
        }
    };

    const handleBillPreview = (mrv) => {
        if (!mrv?.image) {
            Swal.fire("No File", "No document available", "info");
            return;
        }

        const baseUrl = "https://indigoinfra.in";
        const folder = "/img/mrv/";

        const fullUrl = `${baseUrl}${folder}${mrv.image}`;

        console.log("Preview URL:", fullUrl); // 🔥 DEBUG

        setPreviewFile({ url: fullUrl });
        setShowPreview(true);
    };

    const handleMultiBillPreview = (mrvDetails) => {
        try {
            setShowPreview(true);
            setPreviewFile(null); // 🔥 trigger loader

            const baseUrl = "https://indigoinfra.in";
            const folder = "/img/mrv/";

            // ✅ remove duplicate + invalid
            const uniqueMap = new Map();

            mrvDetails.forEach(m => {
                if (m?.image) {
                    uniqueMap.set(m.image, m);
                }
            });

            const validFiles = Array.from(uniqueMap.values());

            // ❌ no files case
            if (validFiles.length === 0) {
                Swal.fire("No Files", "No bills available", "info");
                setShowPreview(false);
                return;
            }

            // ✅ CREATE FILE ARRAY (FINAL)
            const files = validFiles.map(m => ({
                url: `${baseUrl}${folder}${m.image}`,
                type: m.image.toLowerCase().includes(".pdf") ? "pdf" : "image"
            }));

            // 🔥 IMPORTANT: ONLY THIS (NO HTML)
            setPreviewFile({ files });

        } catch (err) {
            console.error(err);
            setShowPreview(false);
            Swal.fire("Error", "Failed to load bills", "error");
        }
    };

    const handleOtherDocPreview = (mrv) => {
        if (!mrv?.otherDoc) {
            Swal.fire("Not Available", "No document available", "info");
            return;
        }

        Swal.fire({
            title: "Loading Preview...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        const baseUrl = "https://indigoinfra.in";
        const fullUrl = `${baseUrl}/img/billing/${mrv.otherDoc}`;

        setPreviewFile({ url: fullUrl });

        setTimeout(() => {
            setShowPreview(true);
            Swal.close();
        }, 300);
    };

    const sortedData = [...tableData].sort((a, b) => {

        if (!sortConfig.key) return 0;

        let valA;
        let valB;

        // ✅ CREATED DATE
        if (sortConfig.key === "createdAt") {
            valA = new Date(a.createdAt);
            valB = new Date(b.createdAt);
        }

        // ✅ BILL DATE
        else if (sortConfig.key === "billingDate") {

            valA = a?.mrvDetails?.[0]?.billingDate
                ? new Date(a.mrvDetails[0].billingDate)
                : new Date(0);

            valB = b?.mrvDetails?.[0]?.billingDate
                ? new Date(b.mrvDetails[0].billingDate)
                : new Date(0);
        }

        // ✅ PO AMOUNT
        else if (sortConfig.key === "totalAmount") {
            valA = Number(a.totalAmount || 0);
            valB = Number(b.totalAmount || 0);
        }

        // ✅ PO NUMBER
        else if (sortConfig.key === "poNumber") {
            valA = Number(a.poNumber || 0);
            valB = Number(b.poNumber || 0);
        }

        // 🔥 ✅ FAILED SUPPLY COUNT (NEW)
        else if (sortConfig.key === "failedSupplyCount") {
            valA = Number(a.failedSupplyCount || 0);
            valB = Number(b.failedSupplyCount || 0);
        }

        // 🔥 ✅ BILL AMOUNT (SUM OF MRVs)
        else if (sortConfig.key === "billAmount") {
            valA = (a.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.totalAmount || 0),
                0
            );

            valB = (b.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.totalAmount || 0),
                0
            );
        }

        // 🔥 ✅ OTHER CHARGES (SUM OF MRVs)
        else if (sortConfig.key === "otherCharges") {
            valA = (a.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.otherCharges || 0),
                0
            );

            valB = (b.mrvDetails || []).reduce(
                (sum, m) => sum + Number(m.otherCharges || 0),
                0
            );
        }

        // ✅ DEFAULT
        else {
            valA = a[sortConfig.key];
            valB = b[sortConfig.key];
        }

        // ✅ FINAL COMPARE
        if (valA < valB) {
            return sortConfig.direction === "asc" ? -1 : 1;
        }

        if (valA > valB) {
            return sortConfig.direction === "asc" ? 1 : -1;
        }

        return 0;
    });
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction:
                prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };

    const supplierOptionsUI = [
        ...new Set(
            sortedData.map(item => item.supplierName).filter(Boolean)
        )
    ];

    const storeOptionsUI = [
        ...new Set(
            sortedData.map(item => item.storeName).filter(Boolean)
        )
    ];

    const statusOptionsUI = [
        ...new Set(
            sortedData.map(item => getStatusLabel(item.status)).filter(Boolean)
        )
    ];

    const poTypeOptionsUI = [
        ...new Set(
            sortedData.map(item => item.poType).filter(Boolean)
        )
    ];


    const filteredData = useMemo(() => {

        let sorted = [...tableData].sort((a, b) => {
            if (!sortConfig.key) return 0;

            let valA;
            let valB;

            if (sortConfig.key === "createdAt") {
                valA = new Date(a.createdAt);
                valB = new Date(b.createdAt);
            } else if (sortConfig.key === "billingDate") {
                valA = a?.mrvDetails?.[0]?.billingDate
                    ? new Date(a.mrvDetails[0].billingDate)
                    : new Date(0);

                valB = b?.mrvDetails?.[0]?.billingDate
                    ? new Date(b.mrvDetails[0].billingDate)
                    : new Date(0);
            } else if (sortConfig.key === "totalAmount") {
                valA = Number(a.totalAmount || 0);
                valB = Number(b.totalAmount || 0);
            } else if (sortConfig.key === "poNumber") {
                valA = Number(a.poNumber || 0);
                valB = Number(b.poNumber || 0);
            } else {
                valA = a[sortConfig.key];
                valB = b[sortConfig.key];
            }

            if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
            if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });

        return sorted.filter((item) => {
            const text = search.toLowerCase();

            const billNo = item?.mrvDetails?.map(m => m.billingNo).join(" ").toLowerCase();
            const mrvNo = item?.mrvDetails?.map(m => m.mrvNo).join(" ").toLowerCase();
            const poNo = item.poNumber?.toLowerCase() || "";
            const reqNo = item?.requisitionNo ? String(item.requisitionNo).toLowerCase() : "";
            const supplier = item.supplierName?.toLowerCase() || "";
            const amount = item.totalAmount?.toString() || "";

            const status = getStatusLabel(item.status);

            return (
                (billNo.includes(text) ||
                    mrvNo.includes(text) ||
                    poNo.includes(text) ||
                    reqNo.includes(text) ||
                    supplier.includes(text) ||
                    amount.includes(text)) &&
                (!statusFilter || status === statusFilter) &&
                (!supplierFilterUI || item.supplierName === supplierFilterUI) &&
                (!storeFilterUI || item.storeName === storeFilterUI) &&
                (!poTypeFilterUI || item.poType === poTypeFilterUI)
            );
        });

    }, [tableData, search, statusFilter, supplierFilterUI, storeFilterUI, poTypeFilterUI, sortConfig]);
    const handleFilterChange = (key, value, setter) => {

        // ✅ update filter directly
        setter(value);

        // ✅ optional tracking only
        if (
            value === "" ||
            value === null ||
            value === 0 ||
            (Array.isArray(value) && value.length === 0)
        ) {
            if (activeFilterKey === key) {
                setActiveFilterKey(null);
            }
        } else {
            setActiveFilterKey(key);
        }
    };

    const handlePOClick = async (item) => {
        const poId =
            item?.poId ||
            item?.po?._id ||
            item?._id;

        if (!poId) {
            Swal.fire(
                "Error",
                "Purchase Order ID is missing.",
                "error"
            );
            return;
        }

        // prevent multiple clicks
        if (printLoadingId) {
            return;
        }

        try {
            setPrintLoadingId(String(poId));

            // clear previous PO
            setSelectedPrintPO(null);

            // ==========================================
            // SAME API USED IN PO MANAGEMENT
            // ==========================================
            const response =
                await POServices.getPurchaseOrderPrintHistory(poId);

            const printData =
                response?.data?.data ||
                response?.data ||
                null;

            const versions =
                Array.isArray(printData?.versions)
                    ? printData.versions
                    : [];

            if (!printData) {
                Swal.fire(
                    "Print Data Missing",
                    "Purchase Order print data was not found.",
                    "warning"
                );
                return;
            }

            if (!versions.length) {
                Swal.fire(
                    "No PO Versions",
                    "Original or revised Purchase Order versions were not found.",
                    "warning"
                );
                return;
            }

            setSelectedPrintPO(printData);
            setShowPOPrintModal(true);

        } catch (error) {

            console.error(
                "BILLING PO PRINT ERROR:",
                error
            );

            Swal.fire(
                "Error",
                error?.response?.data?.message ||
                error?.message ||
                "Unable to load Purchase Order print history.",
                "error"
            );

        } finally {

            setPrintLoadingId("");
        }
    };


    const handleBillingApproveClick = (item) => {

        setSelectedItem(item);

        setShowApproveModal(true);
    };

    const isDefaultView =
        filters.createdMonthRange === 3 &&
        filters.billingMonthRange === 3 &&
        !filters.po &&
        !filters.billNo &&
        !filters.amount &&
        !filters.amountCriteria &&
        (!filters.supplier || filters.supplier.length === 0) &&
        !filters.store;

    const scrollTable = (direction) => {
        const container = document.getElementById("billingTableScroll");
        if (!container) return;

        const scrollAmount = 300;

        container.scrollBy({
            left: direction === "right" ? scrollAmount : -scrollAmount,
            behavior: "smooth"
        });
    };

    const checkScrollEnd = (container) => {
        const scrollLeft = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        const atStart = scrollLeft <= 5;
        const atEnd = scrollLeft >= maxScroll - 5;

        setShowLeft(!atStart);
        setShowRight(!atEnd);
        setIsAtEnd(atEnd);
    };

    useEffect(() => {
        const container = document.getElementById("billingTableScroll");

        if (!container) return;

        checkScrollEnd(container); // 🔥 initial check

        const handleScroll = () => checkScrollEnd(container);

        container.addEventListener("scroll", handleScroll);

        return () => container.removeEventListener("scroll", handleScroll);
    }, [tableData]);


    const handleHistoryClick = (poId) => {

        if (!poId) return;

        setSelectedHistoryPoId(poId);
        setShowHistoryModal(true);

    };


    return (
        <>
            {/* ==========================================
            PO PREVIEW LOADER
        ========================================== */}
            {printLoadingId && (
                <Loader />
            )}
            {/* FILE PREVIEW */}
            <React.Suspense fallback={<LazyLoader text="Loading Preview..." />}>
                {showPreview && (
                    <FilePreviewModal
                        show={showPreview}
                        handleClose={() => setShowPreview(false)}
                        file={previewFile}
                    />
                )}
            </React.Suspense>
            {/* REQUISITION PREVIEW */}
            <React.Suspense fallback={null}>
                {showReqPreview && (
                    <MRVPreviewModal
                        show={showReqPreview}
                        onClose={() => setShowReqPreview(false)}
                        htmlContent={reqHtml}
                        documentType="REQUISITION"

                    />
                )}
            </React.Suspense>

            {/* MRV PREVIEW */}
            <React.Suspense fallback={<LazyLoader text="Loading MRV..." />}>
                {showMRVPreview && (
                    <MRVPreviewModal
                        show={showMRVPreview}
                        onClose={() => setShowMRVPreview(false)}
                        htmlContent={mrvHtml}
                    />
                )}
            </React.Suspense>

            {/* ==========================================
    PO PRINT / REVISION PREVIEW
========================================== */}
            <React.Suspense
                fallback={
                    <LazyLoader text="Loading PO..." />
                }
            >
                {selectedPrintPO && (
                    <PoRevisionPrintModal
                        show={showPOPrintModal}
                        onHide={() => {
                            setShowPOPrintModal(false);
                            setSelectedPrintPO(null);
                        }}
                        printHistory={selectedPrintPO}
                    />
                )}
            </React.Suspense>

            <React.Suspense fallback={null}>
                {showApproveModal && (
                    <BillingApprovalModal
                        show={showApproveModal}
                        handleClose={async () => {

                            setShowApproveModal(false);

                            setSelectedItem(null);

                            await fetchData();

                        }}
                        selectedItem={selectedItem}

                        onUpdateMrv={(updatedMrv) => {

                            // 🔥 UPDATE MAIN TABLE DATA
                            const updatedTable = tableData.map(item => {
                                if (
                                    String(item.poId) !==
                                    String(selectedItem.poId)
                                ) {
                                    return item;
                                }

                                const updatedMrvList = item.mrvDetails.map(m =>
                                    m._id === updatedMrv._id ? updatedMrv : m
                                );

                                return {
                                    ...item,
                                    mrvDetails: updatedMrvList
                                };
                            });

                            setTableData(updatedTable);

                            // 🔥 ALSO UPDATE SELECTED ITEM (MODAL)
                            const updatedSelected = {
                                ...selectedItem,
                                mrvDetails: selectedItem.mrvDetails.map(m =>
                                    m._id === updatedMrv._id ? updatedMrv : m
                                )
                            };

                            setSelectedItem(updatedSelected);
                        }}

                        onUpdateBilling={(updatedBilling) => {

                            const updatedPoId =
                                updatedBilling?.poId ||
                                updatedBilling?._id;

                            const updatedTable = tableData.map(item => {

                                if (
                                    String(item.poId) !==
                                    String(updatedPoId)
                                ) {
                                    return item;
                                }

                                return {
                                    ...item,
                                    ...updatedBilling,
                                    poId: item.poId
                                };
                            });

                            setTableData(updatedTable);

                            setSelectedItem(prev => ({
                                ...prev,
                                ...updatedBilling,
                                poId: prev?.poId
                            }));
                        }}

                        // 🔥 NEW CALLBACK (ONLY FOR APPROVE)
                        onApproveSuccess={async (approvedItem) => {

                            setTableData(prev =>
                                prev.filter(item =>
                                    String(item.poId) !== String(approvedItem.poId)
                                )
                            );

                            await fetchData();
                        }}

                        handlePOClick={handlePOClick}
                        handleMRVPreview={handleMRVPreview}
                        handleMultiMRVPreview={handleMultiMRVPreview}
                        handleBillPreview={handleBillPreview}
                        handleMultiBillPreview={handleMultiBillPreview}
                        handleRequisitionPreview={handleRequisitionPreview}

                    />
                )}
            </React.Suspense>

            {/* PAYMENT HISTORY */}
            <React.Suspense
                fallback={<LazyLoader text="Loading History..." />}
            >
                {showHistoryModal && (
                    <PaymentHistoryModal
                        show={showHistoryModal}
                        onClose={() => {
                            setShowHistoryModal(false);
                            setSelectedHistoryPoId(null);
                        }}
                        poId={selectedHistoryPoId}
                    />
                )}
            </React.Suspense>

            {tableLoading ? (
                <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    style={{ height: "300px" }}
                >
                    <div className="spinner-border text-primary mb-2"></div>

                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#555"
                        }}
                    >
                        Please wait, loading billing details...
                    </div>
                </div>
            ) : (

                <div className={`row ${showApproveModal ? "billing-blur" : ""}`}>
                    <div className="col-xl-12">

                        {/* FILTER */}
                        {open && (

                            <div className="floating-filter-wrapper">
                                <div className="filter cm-content-box box-primary filter-compact glass-filter floating-filter">
                                    <div className="content-title filter-title-clean d-flex justify-content-between align-items-center filter-title-compact">
                                        <div className="cpa">
                                            <i className="fas fa-filter me-2 text-muted"></i>
                                            <span className="text-dark">Filter</span>
                                        </div>

                                        <div>
                                            <Link
                                                to="#"
                                                className="SlideToolHeader"
                                                onClick={() => setOpen(!open)}
                                            >
                                                <i
                                                    className="fas fa-angle-down text-white"
                                                    style={{
                                                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                                        transition: "0.3s"
                                                    }}
                                                ></i>
                                            </Link>
                                        </div>

                                    </div>

                                    <Collapse in={open}>
                                        <div className="card-body filter-body-compact">

                                            <div className="row g-2 align-items-center">

                                                {/* PO */}
                                                <div className="col-xl-2 mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="PO Number"
                                                        value={filters.po}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "po",
                                                                e.target.value,
                                                                (val) => setFilters({ ...filters, po: val })
                                                            );
                                                        }}
                                                    />
                                                </div>

                                                {/* BILL */}
                                                <div className="col-xl-2 mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="Bill Number"
                                                        value={filters.billNo}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "billNo",
                                                                e.target.value,
                                                                (val) => setFilters({ ...filters, billNo: val })
                                                            );
                                                        }}
                                                    />
                                                </div>



                                                {/* SUPPLIER */}
                                                <div className="col-xl-3 mb-3">
                                                    <Select
                                                        isMulti
                                                        classNamePrefix="custom-react-select"
                                                        placeholder="Supplier"
                                                        options={supplierOptions}
                                                        isLoading={supplierLoading}   // 🔥 ADD THIS
                                                        isDisabled={supplierLoading}  // 🔥 OPTIONAL (prevents click)
                                                        value={supplierOptions.filter(opt =>
                                                            filters.supplier.includes(opt.value)
                                                        )}
                                                        onChange={(opts) => {
                                                            const values = opts ? opts.map(o => o.value) : [];

                                                            handleFilterChange(
                                                                "supplier",
                                                                values,
                                                                (val) => setFilters({ ...filters, supplier: val })
                                                            );
                                                        }}
                                                        isClearable
                                                    />
                                                </div>

                                                {/* STORE */}
                                                <div className="col-xl-3 mb-3">
                                                    <Select
                                                        classNamePrefix="custom-react-select"
                                                        placeholder="Store"
                                                        options={storeOptions}
                                                        isLoading={storeLoading}   // 🔥 ADD THIS
                                                        isDisabled={storeLoading}
                                                        value={storeOptions.find(opt => opt.value === filters.store) || null}
                                                        onChange={(opt) => {
                                                            handleFilterChange(
                                                                "store",
                                                                opt?.value || "",
                                                                (val) => setFilters({ ...filters, store: val })
                                                            );
                                                        }}
                                                        isClearable
                                                    />
                                                </div>

                                            </div>
                                            <div className="row">

                                                {/* CRITERIA */}
                                                <div className="col-xl-6 mb-3">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={filters.amountCriteria}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            handleFilterChange(
                                                                "amount",
                                                                value,
                                                                () => setFilters({
                                                                    ...filters,
                                                                    amountCriteria: value,
                                                                    amount: ""
                                                                })
                                                            );
                                                        }}
                                                    >
                                                        <option value="">Select Amount Criteria</option>
                                                        <option value="gt">Greater Than</option>
                                                        <option value="lt">Less Than</option>
                                                        <option value="gte">Greater Than Equal To</option>
                                                        <option value="lte">Less Than Equal To</option>
                                                        <option value="eq">Equal To</option>
                                                    </select>
                                                </div>

                                                {/* AMOUNT INPUT */}
                                                <div className="col-xl-6 mb-3">
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm custom-input"
                                                        placeholder="Enter Amount"
                                                        disabled={!filters.amountCriteria}
                                                        value={filters.amount}
                                                        onChange={(e) => {
                                                            handleFilterChange(
                                                                "amount",
                                                                e.target.value,
                                                                (val) => setFilters({
                                                                    ...filters,
                                                                    amount: val
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>

                                            </div>

                                            {/* 🔥 ROW 3 (SEPARATE RANGE + BUTTONS) */}
                                            {/* 🔥 ROW 3 (SEPARATE RANGE + BUTTONS) */}
                                            <div className="row">

                                                {/* ✅ CREATED AT RANGE */}
                                                <div className="col-xl-6 text-center mb-3">

                                                    <label className="fw-bold mb-1 d-block">
                                                        {filters.createdMonthRange === 0
                                                            ? "PO Creation Range"
                                                            : `Created At : Last ${filters.createdMonthRange} Month(s)`
                                                        }
                                                    </label>

                                                    {/* ✅ SUMMARY (FIXED HEIGHT - NO JUMP) */}
                                                    <div className="range-summary">
                                                        {filters.createdMonthRange > 0 && (() => {

                                                            const { from, to } = getDateRangeFromMonths(
                                                                filters.createdMonthRange
                                                            );

                                                            return (
                                                                <>
                                                                    <strong>Range:</strong>{" "}
                                                                    {new Date(from).toLocaleDateString("en-GB")} →{" "}
                                                                    {new Date(to).toLocaleDateString("en-GB")}
                                                                </>
                                                            );

                                                        })()}
                                                    </div>

                                                    {/* ✅ RANGE */}
                                                    <div className="mx-auto" style={{ maxWidth: "500px" }}>
                                                        <input
                                                            type="range"
                                                            className="form-range mb-0"
                                                            min="0"
                                                            max="36"
                                                            step="3"
                                                            value={filters.createdMonthRange}
                                                            onChange={(e) => {
                                                                const selected = Number(e.target.value);

                                                                handleFilterChange(
                                                                    "range",
                                                                    selected,
                                                                    (val) => setFilters({
                                                                        ...filters,
                                                                        createdMonthRange: val
                                                                    })
                                                                );
                                                            }}
                                                        />

                                                        <div className="d-flex justify-content-between px-1" style={{ fontSize: "12px" }}>
                                                            {[0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36].map((val, i) => (
                                                                <small key={i}>
                                                                    {val === 0 ? "All" : val}
                                                                </small>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ✅ BILLING DATE RANGE */}
                                                <div className="col-xl-6 text-center mb-3">

                                                    <label className="fw-bold mb-1 d-block">
                                                        {filters.billingMonthRange === 0
                                                            ? "Bill Date Range"
                                                            : `Bill Date : Last ${filters.billingMonthRange} Month(s)`
                                                        }
                                                    </label>

                                                    {/* ✅ SUMMARY (FIXED HEIGHT - NO JUMP) */}
                                                    <div className="range-summary">
                                                        {filters.billingMonthRange > 0 && (() => {

                                                            const { from, to } = getDateRangeFromMonths(
                                                                filters.billingMonthRange
                                                            );

                                                            return (
                                                                <>
                                                                    <strong>Range:</strong>{" "}
                                                                    {new Date(from).toLocaleDateString("en-GB")} →{" "}
                                                                    {new Date(to).toLocaleDateString("en-GB")}
                                                                </>
                                                            );

                                                        })()}
                                                    </div>

                                                    {/* ✅ RANGE */}
                                                    <div className="mx-auto" style={{ maxWidth: "500px" }}>
                                                        <input
                                                            type="range"
                                                            className="form-range mb-0"
                                                            min="0"
                                                            max="36"
                                                            step="3"
                                                            value={filters.billingMonthRange}
                                                            onChange={(e) => {
                                                                const selected = Number(e.target.value);

                                                                handleFilterChange(
                                                                    "range",
                                                                    selected,
                                                                    (val) => setFilters({
                                                                        ...filters,
                                                                        billingMonthRange: val
                                                                    })
                                                                );
                                                            }}
                                                        />

                                                        <div className="d-flex justify-content-between px-1" style={{ fontSize: "12px" }}>
                                                            {[0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36].map((val, i) => (
                                                                <small key={i}>
                                                                    {val === 0 ? "All" : val}
                                                                </small>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ✅ BUTTONS */}
                                                <div className="col-xl-12">
                                                    <div className="d-flex justify-content-center gap-2 mt-2">
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={handleSearch}
                                                        >
                                                            Search
                                                        </button>

                                                        <button
                                                            className="btn btn-sm btn-secondary"
                                                            onClick={() => {
                                                                setFilters({
                                                                    billNo: "",
                                                                    supplier: [],
                                                                    po: "",
                                                                    amount: "",
                                                                    amountCriteria: "",
                                                                    createdMonthRange: 3,   // 🔥 FIX
                                                                    billingMonthRange: 3,   // 🔥 FIX
                                                                    store: ""
                                                                });

                                                                setActiveFilterKey(null);
                                                                setTableData([]);
                                                                setIsSearched(false);   // 🔥 ADD THIS
                                                                setIsSearched(false);   // already there
                                                                setOpen(false);         // 🔥 ADD (optional UX fix)
                                                            }}
                                                        >
                                                            Reset
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </Collapse>
                                </div>
                            </div>

                        )}

                        {/* 🔥 BACKDROP ADD HERE */}
                        {open && (
                            <div
                                className="filter-backdrop"
                                onClick={() => setOpen(false)}
                            />
                        )}

                        {/* TABLE */}
                        <div className="filter cm-content-box box-primary table-compact">
                            <div className="content-title billing-header">

                                {/* LEFT */}
                                <div className="billing-header-left">
                                    <i className="fa fa-list me-2" aria-hidden="true"></i>
                                    Procurement & Billing
                                    <span className="badge bg-orange ms-2">
                                        {filteredData.length}
                                    </span>
                                </div>

                                {/* CENTER INFO */}
                                {tableData.length > 0 && (
                                    <div className="billing-header-center">
                                        {!isSearched ? (
                                            <>ℹ️ Showing last <strong>3 months</strong> data</>
                                        ) : (
                                            <>🔍 Showing filtered results</>
                                        )}
                                    </div>
                                )}

                                {/* RIGHT */}
                                <div className="billing-header-right d-flex align-items-center gap-2">

                                    {/* 🔥 FILTER ICON */}
                                    <i
                                        className="fas fa-filter"
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            color: open ? "#0d6efd" : "#6c757d",
                                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "0.3s"
                                        }}
                                        title="Filter"
                                        onClick={() => setOpen(prev => !prev)}
                                    ></i>

                                    {/* EXISTING COLLAPSE */}
                                    <Link
                                        to={"#"}
                                        className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                        onClick={() => setOpen2(!open2)}
                                    >
                                        <i className="fas fa-angle-up"></i>
                                    </Link>

                                </div>

                            </div>
                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row mb-1 g-1 align-items-center filter-row-modern compact">

                                            {/* SEARCH */}
                                            <div className="col-md-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search Bill / MRV / PO / Req / Supplier / Amount"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                            {/* STATUS */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={statusFilter}
                                                    onChange={(e) => setStatusFilter(e.target.value)}
                                                >
                                                    <option value="">Status</option>
                                                    {statusOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* SUPPLIER */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={supplierFilterUI}
                                                    onChange={(e) => setSupplierFilterUI(e.target.value)}
                                                >
                                                    <option value="">Supplier</option>
                                                    {supplierOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* STORE */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={storeFilterUI}
                                                    onChange={(e) => setStoreFilterUI(e.target.value)}
                                                >
                                                    <option value="">Store</option>
                                                    {storeOptionsUI.map((s, i) => (
                                                        <option key={i}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* PO TYPE */}
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={poTypeFilterUI}
                                                    onChange={(e) => setPoTypeFilterUI(e.target.value)}
                                                >
                                                    <option value="">PO Type</option>
                                                    {poTypeOptionsUI.map((p, i) => (
                                                        <option key={i}>{p}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* CLEAR */}
                                            <div className="col-md-1 d-flex align-items-center justify-content-center">
                                                {(search || statusFilter || supplierFilterUI || storeFilterUI || poTypeFilterUI) && (
                                                    <button
                                                        className="btn custom-clear-btn"
                                                        onClick={() => {
                                                            setSearch("");
                                                            setStatusFilter("");
                                                            setSupplierFilterUI("");
                                                            setStoreFilterUI("");
                                                            setPoTypeFilterUI("");
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                        <div className="table-responsive" style={{ position: "relative" }}>

                                            {/* 🔥 OVERLAY LOADER */}
                                            {overlayLoading && (
                                                <div className="overlay-loader">
                                                    <div className="custom-loader"></div>
                                                    <div className="mt-2">Updating...</div>
                                                </div>
                                            )}

                                            <div
                                                id="content_wrapper"
                                                className="dataTables_wrapper no-footer"
                                            >



                                                <div className="table-scroll-container">

                                                    {/* 🔥 LEFT ARROW */}
                                                    {/* LEFT */}
                                                    {showLeft && (
                                                        <div
                                                            className="table-arrow left"
                                                            onClick={() => scrollTable("left")}
                                                        >
                                                            <i className="fas fa-chevron-left"></i>
                                                        </div>
                                                    )}

                                                    {/* RIGHT */}
                                                    {showRight && (
                                                        <div
                                                            className="table-arrow right"
                                                            onClick={() => scrollTable("right")}
                                                        >
                                                            <i className={`fas ${isAtEnd ? "fa-chevron-left" : "fa-chevron-right"}`}></i>
                                                        </div>
                                                    )}

                                                    <div className="po-table-wrapper" id="billingTableScroll">
                                                        <table className="table custom-table-new align-middle">
                                                            <thead
                                                                style={{
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    background: "#eef1f5",
                                                                    borderBottom: "2px solid #dcdcdc",
                                                                    zIndex: 2,
                                                                }}
                                                            >
                                                                <tr>
                                                                    <th>S.No</th>

                                                                    {/* ✅ ACTION AFTER S.NO */}
                                                                    <th className="text-center">Action</th>
                                                                    <th>Status</th>
                                                                    <th>Requisition</th>
                                                                    <th>Store</th>
                                                                    <th
                                                                        onClick={() => handleSort("poNumber")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >PO🔄</th>
                                                                    <th>Type</th>
                                                                    <th onClick={() => handleSort("totalAmount")} style={{ cursor: "pointer" }}>
                                                                        PO Amount 🔄</th>
                                                                    <th>Advance Details</th>
                                                                    <th onClick={() => handleSort("billAmount")} style={{ cursor: "pointer" }}>
                                                                        Bill Amount 🔄
                                                                    </th>
                                                                    <th onClick={() => handleSort("otherCharges")} style={{ cursor: "pointer" }}>
                                                                        Other Charges 🔄</th>
                                                                    <th onClick={() => handleSort("failedSupplyCount")} style={{ cursor: "pointer" }}>
                                                                        Delivery Failed 🔄</th>
                                                                    <th>Bill Title</th>
                                                                    <th>Bill No</th> {/* 🔥 swapped */}
                                                                    <th
                                                                        onClick={() => handleSort("billingDate")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Bill Date 🔄</th>
                                                                    <th>MRV No</th>
                                                                    <th>Other Doc</th>
                                                                    <th>Supplier</th>
                                                                    <th>PO Status</th>
                                                                    <th onClick={() => handleSort("createdAt")} style={{ cursor: "pointer" }}>
                                                                        Date 🔄
                                                                    </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {filteredData.length > 0 ? (
                                                                    filteredData.map((item, index) => (
                                                                        <tr key={item._id}>
                                                                            <td>{index + 1}</td>
                                                                            <td className="text-center">

                                                                                <i
                                                                                    className="fa fa-check-circle text-success"
                                                                                    style={{ cursor: "pointer", fontSize: "18px" }}
                                                                                    title="Approve"
                                                                                    onClick={() => handleBillingApproveClick(item)}
                                                                                ></i>

                                                                            </td>
                                                                            {/* 🔥 STATUS */}
                                                                            <td className="scrollable-description">

                                                                                <div>

                                                                                    <strong
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                            color: "#0d6efd",
                                                                                            textDecoration: "underline"
                                                                                        }}
                                                                                        onClick={() => handleHistoryClick(item.poId)}
                                                                                    >
                                                                                        {item.paymentStatus || "New"}
                                                                                    </strong>

                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        color: "#6b7280",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                >
                                                                                    Click to View History
                                                                                </div>

                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex align-items-center gap-2">

                                                                                    <span>
                                                                                        {item?.requisitionNo || "-"}
                                                                                    </span>

                                                                                    {item?.requisitionNo && (
                                                                                        <i
                                                                                            className="fa fa-eye text-primary"
                                                                                            title="View Requisition"
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleRequisitionPreview(
                                                                                                    item?.requisitionId
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    )}

                                                                                </div>
                                                                            </td>
                                                                            <td className="scrollable-description">{item?.storeName || ''}</td>
                                                                            <td className="align-middle">
                                                                                <div className="d-flex align-items-center gap-2">

                                                                                    <span>
                                                                                        {item?.poNumber || "-"}
                                                                                    </span>

                                                                                    {item?.poNumber && (
                                                                                        <i
                                                                                            className="fa fa-eye text-primary"
                                                                                            title="View PO"
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                            onClick={() => handlePOClick(item)}
                                                                                        />
                                                                                    )}

                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                {item.poType || "Normal"}
                                                                            </td>
                                                                            <td className="scrollable-description">
                                                                                {item.totalAmount !== undefined && item.totalAmount !== null
                                                                                    ? Number(item.totalAmount).toFixed(2)
                                                                                    : "-"}
                                                                            </td>
                                                                            <td>
                                                                                {(item.advanceRentalAmount ?? 0) > 0 || (item.advanceRentalPercent ?? 0) > 0 ? (
                                                                                    <div>
                                                                                        <div>
                                                                                            Amount: ₹ {Number(item.advanceRentalAmount || 0).toFixed(2)}
                                                                                        </div>
                                                                                        <div>
                                                                                            Percentage: {item.advanceRentalPercent || 0}%
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>
                                                                            {/* ✅ BILL AMOUNT */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.totalAmount ?? "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>
                                                                            {/* ✅ OTHER CHARGES */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.otherCharges ?? "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {item?.failedSupplyCount > 0 ? (
                                                                                    <span
                                                                                        title="Click to view Requisition"
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                            background: "#fff4e5",
                                                                                            color: "#92400e",
                                                                                            padding: "3px 8px",
                                                                                            borderRadius: "6px",
                                                                                            fontSize: "12px",
                                                                                            fontWeight: "500",
                                                                                            display: "inline-block"
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (item?.requisitionId) {
                                                                                                handleFailedRequisitionPreview(item.requisitionId, item.poNumber)
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {item.failedSupplyCount}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span style={{ color: "#9ca3af" }}>0</span>
                                                                                )}
                                                                            </td>
                                                                            {/* ✅ BILL TITLE */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.billingTitle?.trim()
                                                                                                ? m.billingTitle
                                                                                                : "-"}
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>

                                                                            {/* ✅ BILL NUMBER */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (
                                                                                    <>
                                                                                        {/* ✅ SINGLE BILL */}
                                                                                        {item.mrvDetails.map((m, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                className="d-flex align-items-center gap-2"
                                                                                            >
                                                                                                <span>
                                                                                                    {m?.billingNo || "-"}
                                                                                                </span>

                                                                                                {m?.image && (
                                                                                                    <i
                                                                                                        className="fa fa-eye text-primary"
                                                                                                        title="View Bill"
                                                                                                        style={{
                                                                                                            cursor: "pointer",
                                                                                                            fontSize: "14px"
                                                                                                        }}
                                                                                                        onClick={() => handleBillPreview(m)}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ))}

                                                                                        {/* ✅ MULTI BILL ACTION - KEEP EXISTING */}
                                                                                        {item.mrvDetails.filter(m => m.image).length > 1 && (
                                                                                            <div
                                                                                                className="table-action-link"
                                                                                                onClick={() =>
                                                                                                    handleMultiBillPreview(item.mrvDetails)
                                                                                                }
                                                                                            >
                                                                                                + View All (
                                                                                                {item.mrvDetails.filter(m => m.image).length}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>
                                                                            {/* ✅ BILL DATE */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0
                                                                                    ? item.mrvDetails.map((m, i) => (
                                                                                        <div key={i}>
                                                                                            {m?.billingDate
                                                                                                ? new Date(m.billingDate).toLocaleDateString("en-GB")
                                                                                                : "-"
                                                                                            }
                                                                                        </div>
                                                                                    ))
                                                                                    : "-"
                                                                                }
                                                                            </td>



                                                                            {/* ✅ MRV NUMBERS */}
                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (
                                                                                    <>
                                                                                        {/* ✅ SINGLE MRV */}
                                                                                        {item.mrvDetails.map((m, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                className="d-flex align-items-center gap-2"
                                                                                            >
                                                                                                <span>
                                                                                                    {m?.mrvNo || "-"}
                                                                                                </span>

                                                                                                {m?._id && (
                                                                                                    <i
                                                                                                        className="fa fa-eye text-primary"
                                                                                                        title="View MRV"
                                                                                                        style={{
                                                                                                            cursor: "pointer",
                                                                                                            fontSize: "14px"
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            handleMRVPreview(m._id)
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ))}

                                                                                        {/* ✅ MULTI MRV ACTION - KEEP EXISTING */}
                                                                                        {item.mrvDetails.filter(m => m?._id).length > 1 && (
                                                                                            <div
                                                                                                className="table-action-link"
                                                                                                onClick={() =>
                                                                                                    handleMultiMRVPreview(
                                                                                                        item.mrvDetails
                                                                                                            .filter(m => m?._id)
                                                                                                            .map(m => m._id)
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                + View All (
                                                                                                {item.mrvDetails.filter(m => m?._id).length}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>


                                                                            <td className="scrollable-description">
                                                                                {item?.mrvDetails?.length > 0 ? (() => {

                                                                                    // ✅ check if ANY doc exists
                                                                                    const hasAnyDoc = item.mrvDetails.some(m => m.otherDoc);

                                                                                    // ❌ if none → show single NA
                                                                                    if (!hasAnyDoc) {
                                                                                        return <span style={{ color: "gray" }}>Not Available</span>;
                                                                                    }

                                                                                    // ✅ if exists → show only available docs
                                                                                    return item.mrvDetails
                                                                                        .filter(m => m.otherDoc)
                                                                                        .map((m, i) => (
                                                                                            <div key={i}>
                                                                                                <span
                                                                                                    style={{
                                                                                                        color: "green",
                                                                                                        cursor: "pointer",
                                                                                                        textDecoration: "underline"
                                                                                                    }}
                                                                                                    onClick={() => handleOtherDocPreview(m)}
                                                                                                >
                                                                                                    {`Doc ${i + 1}`}
                                                                                                </span>
                                                                                            </div>
                                                                                        ));

                                                                                })() : "-"}
                                                                            </td>
                                                                            <td className="scrollable-description">{item.supplierName}</td>


                                                                            <td className="scrollable-description">{getStatusLabel(item.status)}</td>
                                                                            <td>{formatDateTime(item.createdAt)}</td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="15" className="text-center text-muted py-4">
                                                                            No records found
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                }
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                    </div>
                </div>

            )}

        </>
    );
};

export default BillingTeam;